import React from 'react';

interface RazorpayCheckoutProps {
    amount: number; // Amount in rupees
    currency?: string;
    name: string;
    email: string;
    phone: string;
    description: string;
    onSuccess: (response: any) => void;
    onError: (error: any) => void;
    onCancel: () => void;
}

declare global {
    interface Window {
        Razorpay: any;
    }
}

const RazorpayCheckout: React.FC<RazorpayCheckoutProps> = ({
    amount,
    currency = 'INR',
    name,
    email,
    phone,
    description,
    onSuccess,
    onError,
    onCancel
}) => {
    const keyId = process.env.REACT_APP_RAZORPAY_KEY_ID;

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const handlePayment = async () => {
        const res = await loadRazorpayScript();

        if (!res) {
            alert('Razorpay SDK failed to load. Please check your internet connection.');
            return;
        }

        if (!keyId) {
            alert('Razorpay Key ID not configured. Please add REACT_APP_RAZORPAY_KEY_ID to your .env file');
            return;
        }

        const options = {
            key: keyId,
            amount: amount * 100, // Razorpay expects amount in paise
            currency: currency,
            name: 'Manjushree Foundation',
            description: description,
            image: '/logo.png', // Your logo
            handler: function (response: any) {
                onSuccess(response);
            },
            prefill: {
                name: name,
                email: email,
                contact: phone,
            },
            notes: {
                description: description,
            },
            theme: {
                color: '#F4C430', // Your theme color
            },
            modal: {
                ondismiss: function () {
                    onCancel();
                },
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.on('payment.failed', function (response: any) {
            onError(response.error);
        });
        paymentObject.open();
    };

    if (!keyId) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#dc2626' }}>
                <p>⚠️ Razorpay Key ID not configured</p>
                <p style={{ fontSize: '12px', marginTop: '8px' }}>
                    Please add REACT_APP_RAZORPAY_KEY_ID to your .env file
                </p>
            </div>
        );
    }

    return (
        <div style={{ textAlign: 'center', padding: '10px 0' }}>
            <button
                onClick={handlePayment}
                style={{
                    padding: '12px 24px',
                    background: 'linear-gradient(135deg, #F4C430 0%, #E6B82E 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    width: '100%',
                    boxShadow: '0 4px 12px rgba(244, 196, 48, 0.3)',
                    transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(244, 196, 48, 0.4)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(244, 196, 48, 0.3)';
                }}
            >
                Pay ₹{amount.toLocaleString('en-IN')} with Razorpay
            </button>
            <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '12px' }}>
                Supports UPI, Cards, Net Banking, QR Code & Wallets
            </p>
        </div>
    );
};

export default RazorpayCheckout;
